import { Component, h } from '@stencil/core';

@Component({
  tag: 'uui-divider-horizontal',
  shadow: true
})
export class UuiDividerHorizontal {
  render() {
    return <uui-divider vertical={false}></uui-divider>;
  }
}